import React from "react";
import { Typography, Box } from "@material-ui/core";
import { ApproversTimeline } from "./ApproversTimeline";
import { useDialogStyles } from "../styles/dialogStyles";
import { getStageStatus, getStatusColor } from "../utils/statusUtils";
import { TFunction } from "i18next";

interface StageCardProps {
    stage: Compleo.JobApproval.stageWithApproversStatus;
    stageIndex: number;
    t: TFunction;
    jobStatus: CompleoShared.Common.JobStatus;
}

export function StageCard({ stage, stageIndex, t, jobStatus }: StageCardProps) {
    const classes = useDialogStyles();
    const stageStatus = getStageStatus(stage, jobStatus);
    const approvers = stage.approverStatus || [];
    const approvedCount = approvers.filter(
        (a) => a.actionResult?.status === "approved"
    ).length;

    return (
        <>
            <div className={classes.stageHeader}>
                <div
                    className={classes.stageNumber}
                    style={{ backgroundColor: getStatusColor(stageStatus) }}
                >
                    {stageIndex + 1}
                </div>
                <Box flex={1}>
                    <Typography className={classes.stageTitle}>
                        {stage.name}
                        <span className={classes.stageType}>
                            ({t(`type_${stage.approvalLogic?.value}`)})
                        </span>
                    </Typography>
                    <Box display="flex" alignItems="center" mt={0.5}>
                        <span
                            className={classes.stageStatus}
                            style={{
                                backgroundColor: getStatusColor(stageStatus)
                            }}
                        >
                            {t(stageStatus)}
                        </span>
                        <Typography className={classes.stageProgress}>
                            {t("stageStatus", {
                                numberOfApprovers: approvedCount,
                                totalApprovers: approvers.length
                            })}
                        </Typography>
                    </Box>
                </Box>
            </div>
            <ApproversTimeline
                approvers={approvers}
                t={t}
                stageStatus={stageStatus}
                jobStatus={jobStatus}
            />
        </>
    );
}
